import React from 'react';
import PhoneInput from 'react-phone-input-2';
import Select from 'react-select';
import ErrorSvg from '../../assets/error.svg';
import {
  Container,
  Wrapper,
  Label,
  Astericks,
  Input,
  ErrorIcon,
  ErrorMessage,
  SelectStyles,
} from '../styles/FormControl.styled';

const FormControl = ({
  id,
  type,
  name,
  placeholder,
  label,
  autoComplete,
  required,
  errorMessage,
  value,
  handleChange,
  hidden,
  options,
}) => {
  const renderInput = () => {
    if (type === 'select') {
      return (
        <Select
          styles={SelectStyles}
          name={name}
          options={options}
          defaultValue={value ? { label: value } : null}
          placeholder={placeholder}
          isSearchable={false}
          onChange={e => handleChange(name, e.value)}
        />
      );
    }
    return (
      <Input
        id={id}
        type={type}
        name={name}
        placeholder={placeholder}
        autoComplete={autoComplete}
        defaultValue={value}
        className={errorMessage ? 'error' : ''}
        onChange={e => handleChange(e)}
      />
    );
  };

  return (
    <Container
      className={`custom-form-control control-${name}`}
      hidden={hidden}
    >
      <Wrapper>
        <Label htmlFor={name}>
          {label}
          {required && <Astericks>*</Astericks>}
        </Label>
        {renderInput()}
        {errorMessage && (
          <ErrorIcon className="error-icon" src={ErrorSvg} alt="Error Icon" />
        )}
      </Wrapper>
      {errorMessage && (
        <ErrorMessage
          className="error-message"
          dangerouslySetInnerHTML={{ __html: errorMessage }}
        />
      )}
    </Container>
  );
};

export default FormControl;
